
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/inventory-management-software",
      function () {
        return require("private-next-pages/features/inventory-management-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/inventory-management-software"])
      });
    }
  